import React, { useState } from 'react';
import YouTube from 'react-youtube';
//
import dabangBridge from '~/utils/bridge';
import ga from '~/utils/ga';
import isMobile from '~/utils/is-mobile';
//
import main from './images/main.png';
import description from './images/description.png';
//
import { BGWrap, YoutubeWrap, Btn } from './styled';



const WematchEventAgain = () => {
  const isM = isMobile.any();
  const [video, setVideo] = useState(null);

  function onReady(event) {
    setVideo(event.target);
  }

  const onClickButtonhandler = () => {
    //모웹접근
    if (dabangBridge.getPlatform() === 'web' && isM) {
      return window.location.href = 'https://dabang.page.link/9Vrq';
    } else {
      const params = {
        api_type: 'BBOX',
        location: JSON.stringify([
          [125.38564393561512, 32.320189184386535],
          [129.9669425751472, 38.85305442043736],
        ]),
        zoom: 9,
      };
  
      ga('22-06_위매치다이사', '다방싸인매물리스트_click', '');
  
      dabangBridge.web(call => {
        console.log('web');
        window.location.href = `https://dabangapp.com/search/map?filters=%7B%22multi_room_type%22%3A%5B2%2C1%2C0%5D%2C%22selling_type%22%3A%5B0%2C1%2C2%5D%2C%22deposit_range%22%3A%5B0%2C999999%5D%2C%22price_range%22%3A%5B0%2C999999%5D%2C%22trade_range%22%3A%5B0%2C999999%5D%2C%22maintenance_cost_range%22%3A%5B0%2C999999%5D%2C%22room_size%22%3A%5B0%2C999999%5D%2C%22supply_space_range%22%3A%5B0%2C999999%5D%2C%22room_floor_multi%22%3A%5B1%2C2%2C3%2C4%2C5%2C6%2C7%2C-1%2C0%5D%2C%22division%22%3Afalse%2C%22duplex%22%3Afalse%2C%22room_type%22%3A%5B1%2C2%5D%2C%22use_approval_date_range%22%3A%5B0%2C999999%5D%2C%22parking_average_range%22%3A%5B0%2C999999%5D%2C%22household_num_range%22%3A%5B0%2C999999%5D%2C%22parking%22%3Afalse%2C%22short_lease%22%3Afalse%2C%22full_option%22%3Afalse%2C%22built_in%22%3Afalse%2C%22elevator%22%3Afalse%2C%22balcony%22%3Afalse%2C%22safety%22%3Afalse%2C%22pano%22%3Afalse%2C%22deal_type%22%3A%5B0%2C1%5D%7D&position=%7B%22location%22%3A%5B%5B126.4666758%2C37.3410879%5D%2C%5B127.4815378%2C37.7879406%5D%5D%2C%22center%22%3A%5B126.9741068%2C37.5648493%5D%2C%22zoom%22%3A11%7D&search=%7B%22id%22%3A%22%22%2C%22type%22%3A%22%22%2C%22name%22%3A%22%22%7D&tab=sign`;
      });
  
      dabangBridge.android(call => {
        console.log('android');
        video && video.pauseVideo();
        call.signRoomList(JSON.stringify(params));
      });
  
      dabangBridge.ios(call => {
        video && video.pauseVideo();
        call.callHandler('ObjC Echo', {
          cmd: 'signRoomList',
          params: params,
        });
      });
    }
  };

  return (
    <>
      <BGWrap width={1200} height={1621} imgUrl={main} >
        <YoutubeWrap>
          <YouTube videoId="N-8uWemus9o" onReady={onReady} />
        </YoutubeWrap>
      </BGWrap>
      <BGWrap width={710} height={1407} imgUrl={description}>
        <Btn onClick={onClickButtonhandler} />
      </BGWrap>
    </>
  );
};

export default WematchEventAgain;
